import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, withKeys as _withKeys, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, createSlots as _createSlots, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-04d3b4be"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "common-page account-manage-page" }
const _hoisted_2 = { class: "page-title fh-c-b" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "bold" }, [
  /*#__PURE__*/_createElementVNode("span", null, "账号管理"),
  /*#__PURE__*/_createElementVNode("a", { href: "#/system_setting/engineers/run_engineers" }, "（回到旧版）")
], -1))
const _hoisted_4 = { class: "fh-c" }
const _hoisted_5 = /*#__PURE__*/_createTextVNode("清除搜索条件")
const _hoisted_6 = /*#__PURE__*/_createTextVNode("取消选中条件")
const _hoisted_7 = {
  class: "fh",
  style: {"height":"calc(100% - 46px)"}
}
const _hoisted_8 = { class: "organization-area" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_button = _resolveComponent("a-button")!
  const _component_SearchOutlined = _resolveComponent("SearchOutlined")!
  const _component_a_input = _resolveComponent("a-input")!
  const _component_CaretDownOutlined = _resolveComponent("CaretDownOutlined")!
  const _component_senior_search = _resolveComponent("senior-search")!
  const _component_a_dropdown_button = _resolveComponent("a-dropdown-button")!
  const _component_a_menu_item = _resolveComponent("a-menu-item")!
  const _component_a_menu = _resolveComponent("a-menu")!
  const _component_organization = _resolveComponent("organization")!
  const _component_account_table = _resolveComponent("account-table")!
  const _component_modal_edit_group = _resolveComponent("modal-edit-group")!
  const _component_modal_edit = _resolveComponent("modal-edit")!
  const _component_modal_export_excel = _resolveComponent("modal-export-excel")!
  const _component_modal_import = _resolveComponent("modal-import")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _hoisted_3,
        _createElementVNode("div", _hoisted_4, [
          (_ctx.showClear)
            ? (_openBlock(), _createBlock(_component_a_button, {
                key: 0,
                type: "link",
                size: "small",
                onClick: _ctx.handleClear
              }, {
                default: _withCtx(() => [
                  _hoisted_5
                ]),
                _: 1
              }, 8, ["onClick"]))
            : _createCommentVNode("", true),
          (_ctx.selectedRows.length === 0)
            ? (_openBlock(), _createBlock(_component_a_input, {
                key: 1,
                value: _ctx.searchKey,
                "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.searchKey) = $event)),
                style: {"width":"250px"},
                placeholder: "姓名/email/手机号/ExternalId",
                allowClear: "",
                onKeyup: _withKeys(_ctx.handleSearch, ["enter"])
              }, {
                suffix: _withCtx(() => [
                  _createVNode(_component_SearchOutlined, {
                    style: {"cursor":"pointer"},
                    onClick: _ctx.handleSearch
                  }, null, 8, ["onClick"])
                ]),
                _: 1
              }, 8, ["value", "onKeyup"]))
            : _createCommentVNode("", true),
          (_ctx.selectedRows.length === 0)
            ? (_openBlock(), _createBlock(_component_a_dropdown_button, {
                key: 2,
                class: "hide-btn",
                trigger: ['click'],
                visible: _ctx.visible.search,
                "onUpdate:visible": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.visible.search) = $event))
              }, {
                icon: _withCtx(() => [
                  _createVNode(_component_CaretDownOutlined)
                ]),
                overlay: _withCtx(() => [
                  _createVNode(_component_senior_search, {
                    "service-desk-id": _ctx.engineerQuery.defaultServiceDeskId,
                    onSubmit: _ctx.handleSeniorSearch,
                    ref: "seniorRef"
                  }, null, 8, ["service-desk-id", "onSubmit"])
                ]),
                _: 1
              }, 8, ["visible"]))
            : _createCommentVNode("", true),
          (_ctx.selectedRows.length === 0 && _ctx.menuWithNotSelect.length > 0)
            ? (_openBlock(), _createBlock(_component_a_dropdown_button, {
                key: 3,
                class: "ml10",
                trigger: ['click']
              }, _createSlots({
                icon: _withCtx(() => [
                  _createVNode(_component_CaretDownOutlined)
                ]),
                default: _withCtx(() => [
                  _createElementVNode("div", {
                    onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.menuWithNotSelect[0].fun && _ctx.menuWithNotSelect[0].fun(...args)))
                  }, _toDisplayString(_ctx.menuWithNotSelect[0].name), 1)
                ]),
                _: 2
              }, [
                (_ctx.menuWithNotSelect.length > 1)
                  ? {
                      name: "overlay",
                      fn: _withCtx(() => [
                        _createVNode(_component_a_menu, null, {
                          default: _withCtx(() => [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.menuWithNotSelect.slice(1), (item, index) => {
                              return (_openBlock(), _createBlock(_component_a_menu_item, {
                                key: index,
                                onClick: item.fun
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(item.name), 1)
                                ]),
                                _: 2
                              }, 1032, ["onClick"]))
                            }), 128))
                          ]),
                          _: 1
                        })
                      ])
                    }
                  : undefined
              ]), 1024))
            : _createCommentVNode("", true),
          (_ctx.selectedRows.length > 0)
            ? (_openBlock(), _createBlock(_component_a_button, {
                key: 4,
                type: "link",
                size: "small",
                onClick: _ctx.handleCancel
              }, {
                default: _withCtx(() => [
                  _hoisted_6
                ]),
                _: 1
              }, 8, ["onClick"]))
            : _createCommentVNode("", true),
          (_ctx.selectedRows.length > 0 && _ctx.menuWithSelected.length > 0)
            ? (_openBlock(), _createBlock(_component_a_dropdown_button, {
                key: 5,
                class: "ml10",
                trigger: ['click']
              }, _createSlots({
                icon: _withCtx(() => [
                  _createVNode(_component_CaretDownOutlined)
                ]),
                default: _withCtx(() => [
                  _createElementVNode("div", {
                    onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.menuWithSelected[0].fun && _ctx.menuWithSelected[0].fun(...args)))
                  }, _toDisplayString(_ctx.menuWithSelected[0].name), 1)
                ]),
                _: 2
              }, [
                (_ctx.menuWithSelected.length > 1)
                  ? {
                      name: "overlay",
                      fn: _withCtx(() => [
                        _createVNode(_component_a_menu, null, {
                          default: _withCtx(() => [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.menuWithSelected.slice(1), (item, index) => {
                              return (_openBlock(), _createBlock(_component_a_menu_item, {
                                key: index,
                                onClick: item.fun
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(item.name), 1)
                                ]),
                                _: 2
                              }, 1032, ["onClick"]))
                            }), 128))
                          ]),
                          _: 1
                        })
                      ])
                    }
                  : undefined
              ]), 1024))
            : _createCommentVNode("", true)
        ])
      ]),
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("div", _hoisted_8, [
          _createVNode(_component_organization, {
            modelValue: _ctx.engineerQuery.serviceDeskId,
            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.engineerQuery.serviceDeskId) = $event)),
            hadSunloginWeb: _ctx.hadSunloginWeb
          }, null, 8, ["modelValue", "hadSunloginWeb"])
        ]),
        _createVNode(_component_account_table, {
          ref: "tableRef",
          engineerQuery: _ctx.engineerQuery,
          hadSunloginWeb: _ctx.hadSunloginWeb,
          selectedRows: _ctx.selectedRows,
          "onUpdate:selectedRows": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.selectedRows) = $event))
        }, null, 8, ["engineerQuery", "hadSunloginWeb", "selectedRows"])
      ])
    ]),
    _createVNode(_component_modal_edit_group, {
      serviceDeskStatus: "1",
      visible: _ctx.visible.editGroup,
      "onUpdate:visible": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.visible.editGroup) = $event)),
      "selected-accounts": _ctx.selectedRows,
      onRefresh: _ctx.handleRefresh
    }, null, 8, ["visible", "selected-accounts", "onRefresh"]),
    _createVNode(_component_modal_edit, {
      visible: _ctx.visible.edit,
      "onUpdate:visible": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.visible.edit) = $event)),
      "had-sunlogin-web": _ctx.hadSunloginWeb,
      "selected-accounts": _ctx.selectedRows,
      onRefresh: _ctx.handleRefresh
    }, null, 8, ["visible", "had-sunlogin-web", "selected-accounts", "onRefresh"]),
    _createVNode(_component_modal_export_excel, {
      visible: _ctx.visible.export,
      "onUpdate:visible": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.visible.export) = $event)),
      "search-key": _ctx.engineerQuery.searchKey
    }, null, 8, ["visible", "search-key"]),
    _createVNode(_component_modal_import, {
      visible: _ctx.visible.import,
      "onUpdate:visible": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.visible.import) = $event))
    }, null, 8, ["visible"])
  ], 64))
}